/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2017-2023 Brett Zamir, 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"

// Use a lookup table to find the index.
const lookup = new Uint8Array(256)
for (let i = 0; i < chars.length; i++) {
  lookup[chars.codePointAt(i)!] = i
}

export function fromBase64(
  base64: string,
  options: {
    maxByteLength?: number
  } = {}
): ArrayBuffer {
  const len = base64.length

  if (len % 4) {
    throw new Error("Bad base64 length: not divisible by four")
  }

  let bufferLength = base64.length * 0.75
  let p = 0
  let encoded1
  let encoded2
  let encoded3
  let encoded4

  if (base64.at(-1) === "=") {
    bufferLength--
    if (base64.at(-2) === "=") {
      bufferLength--
    }
  }

  const arraybuffer = new ArrayBuffer(bufferLength, options)
  const bytes = new Uint8Array(arraybuffer)

  for (let i = 0; i < len; i += 4) {
    // We know the result will not be undefined, as we have a text
    //   length divisible by four
    encoded1 = lookup[base64.codePointAt(i)!]
    encoded2 = lookup[base64.codePointAt(i + 1)!]
    encoded3 = lookup[base64.codePointAt(i + 2)!]
    encoded4 = lookup[base64.codePointAt(i + 3)!]

    bytes[p++] = (encoded1 << 2) | (encoded2 >> 4)
    bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2)
    bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63)
  }

  return arraybuffer
}
